import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('rubricBank');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.created.state,
        ...EdverumTable.searchTag.state,
        ...EdverumTable.searchGroup.state,
        ...EdverumTable.viewArchived.state,
    },

    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
        ...EdverumTable.searchGroup.getters,
        ...collectionHelpers.getters,
        ...EdverumTable.viewArchived.getters,
    },

    actions: {
        ...EdverumTable.created.actions,

        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags('/api/tags?type=rubric_bank'),

        fetchAssignableGroups: collectionHelpers.actions.fetchAssignableGroups(),

        reset: collectionHelpers.actions.reset('RubricBanks'),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.created.mutations,
        ...EdverumTable.searchTag.mutations,
        ...EdverumTable.searchGroup.mutations,
        SET_ASSIGNABLE_GROUPS: collectionHelpers.mutations.SET_ASSIGNABLE_GROUPS,
    },
};
